import { AddIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Icon,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { apiurl } from "APIURL";
import axios from "axios";
import Card from "components/card/Card";
import React, { useState } from "react";
import { MdUpload } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setRessource, setRessourceType } from "redux/slices/AddCourseSlice";
import {
  getAddRessourceData,
  setLoadingRessource,
  setName,
} from "redux/slices/addRessourceSlice";
import Dropzone from "views/admin/profile/components/Dropzone";

interface AddRessourceProps {
  submitHandler: (e: React.FormEvent) => void;
  courseId: number;
}
const AddRessource: React.FC<AddRessourceProps> = ({
  submitHandler,
}: AddRessourceProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useAppDispatch();
  const { name, fileUrl, loading } = useAppSelector(getAddRessourceData);
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const brandColor = useColorModeValue("brand.500", "white");
  const textColorSecondary = "gray.400";
  const [fileInputState, setFileInputState] = useState("");
  const [previewSource, setPreviewSource] = useState(null);
  const [selectedFile, setSelectedFile] = useState();
  const [successMsg, setSuccessMsg] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [disabled, setDisabled] = useState(false);
  const handleFileInputChange = React.useCallback((acceptedFiles: any) => {
    console.log("changing");
    /*const file = files.target.files[0];
        previewFile(file);
        setSelectedFile(file);
        setFileInputState(files.target.value);*/
    previewFile(acceptedFiles[0]);
    setSelectedFile(acceptedFiles[0]);
    setFileInputState(acceptedFiles[0]);
    acceptedFiles.forEach((file: any) => {
      const reader = new FileReader();

      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.onload = () => {
        // Do whatever you want with the file contents
        const binaryStr = reader.result;
        console.log(binaryStr);
      };
      reader.readAsArrayBuffer(file);
    });
  }, []);

  const previewFile = (file: any) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setPreviewSource(reader.result);
    };
  };

  const handleSubmitFile = () => {
    //e.preventDefault();
    console.log("clicked");
    if (!selectedFile) return;
    const reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onloadend = () => {
      uploadImage(selectedFile);
    };
    reader.onerror = () => {
      console.error("AHHHHHHHH!!");
      setErrMsg("something went wrong!");
    };
    setDisabled(true);
  };

  const uploadImage = async (file: File) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      for (var key of formData.entries()) {
        console.log(key[0] + ", " + new Object(key[1]));
      }

      const response = await axios.post(apiurl + "/file/upload", formData);
      console.log(response.data);
      dispatch(setRessource(response.data));
      dispatch(setRessourceType(file.type));

      dispatch(setLoadingRessource(false));

      setFileInputState("");
      setPreviewSource("");
      setSuccessMsg("Image uploaded successfully");
      console.log(successMsg);
    } catch (err) {
      console.error(err);
      setErrMsg("Something went wrong!");
      console.log(errMsg);
    }
  };
  return (
    <>
      <Button leftIcon={<AddIcon />} colorScheme={"brand"} onClick={onOpen}>
        Ajouter Ressource
      </Button>

      <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <form action="">
          <ModalContent>
            <ModalHeader>Ajouter un Ressource</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl id="email">
                <FormLabel>Nom de Ressource</FormLabel>
                <Input
                  value={name}
                  onChange={(e) => dispatch(setName(e.target.value))}
                  borderRadius={"full"}
                  type="text"
                />
              </FormControl>

              <FormControl id="email">
                <FormLabel>Fichiers</FormLabel>
                <Card mb="20px" alignItems="center" p="20px">
                  <Flex h="100%" direction={{ base: "column", "2xl": "row" }}>
                    <Dropzone
                      onDrop={handleFileInputChange}
                      w={{ base: "100%", "2xl": "268px" }}
                      me="36px"
                      maxH={{ base: "60%", lg: "50%", "2xl": "100%" }}
                      minH={{ base: "60%", lg: "50%", "2xl": "100%" }}
                      content={
                        <Box>
                          <Icon
                            as={MdUpload}
                            w="80px"
                            h="80px"
                            color={brandColor}
                          />
                          <Flex justify="center" mx="auto" mb="12px">
                            <Text
                              fontSize="xl"
                              fontWeight="700"
                              color={brandColor}
                            >
                              Choisir image
                            </Text>
                          </Flex>
                          <Text
                            fontSize="sm"
                            fontWeight="500"
                            color="secondaryGray.500"
                          >
                            PDF, PNG, JPG, DOC et MP4 sont autorisés
                          </Text>
                        </Box>
                      }
                      value={fileInputState}
                    />
                    <Flex direction="column" pe="44px">
                      {previewSource ? (
                        <Image src={previewSource} />
                      ) : (
                        <>
                          <Text
                            color={textColorPrimary}
                            fontWeight="bold"
                            textAlign="start"
                            fontSize="2xl"
                            mt={{ base: "20px", "2xl": "50px" }}
                          >
                            Ajouter une fichier comme ressource du cours
                          </Text>
                          <Text
                            color={textColorSecondary}
                            fontSize="md"
                            my={{ base: "auto", "2xl": "10px" }}
                            mx="auto"
                            textAlign="start"
                          ></Text>
                        </>
                      )}
                      <Flex w="100%">
                        <Button
                          onClick={handleSubmitFile}
                          me="100%"
                          mb="50px"
                          w="140px"
                          minW="140px"
                          variant="brand"
                          mt={{ base: "20px", "2xl": "auto" }}
                          fontWeight="500"
                        >
                          {loading === true ? (
                            <Spinner />
                          ) : (
                            "Publier maintenant"
                          )}
                        </Button>
                      </Flex>
                    </Flex>
                  </Flex>
                </Card>
              </FormControl>
              <Stack my={5} direction="row" spacing={"auto"}></Stack>
            </ModalBody>

            <ModalFooter>
              <Button
                type="button"
                onClick={(e) => {
                  submitHandler(e);
                  onClose();
                }}
                colorScheme="brand"
                mr={3}
              >
                Enregistrer
              </Button>
              <Button onClick={onClose}>Annuler</Button>
            </ModalFooter>
          </ModalContent>
        </form>
      </Modal>
    </>
  );
};
export default AddRessource;
